/**
 * CSV encoding for admin exports. Cells are quoted only when needed, and any
 * cell a spreadsheet would evaluate as a formula gets a leading apostrophe:
 * names, bios, and links are coach-written, so opening an export must never
 * run them.
 *
 * Aliases: csv export, to csv, csv escape, spreadsheet export, csv injection,
 * formula injection
 */

const FORMULA_PREFIX = /^[=+\-@\t\r]/;
const NEEDS_QUOTES = /[",\r\n]|^\s|\s$/;

export function toCsvCell(value: string): string {
  const inert = FORMULA_PREFIX.test(value) ? `'${value}` : value;
  return NEEDS_QUOTES.test(inert) ? `"${inert.replaceAll('"', '""')}"` : inert;
}

export function toCsv(
  header: readonly string[],
  rows: readonly (readonly string[])[],
): string {
  return [header, ...rows]
    .map((cells) => cells.map(toCsvCell).join(","))
    .join("\r\n");
}
